import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getClientesPaginados,
  getAllPropiedadesPaginadas,
  getProspectos,
  getUsuario,
  setComunas,
  getLatestCierreMesBroker,
} from "../../action";
import { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import utilsFunc from "../../utils/utilsFunctions";
import ModalEditarDatosPersonales from "./ModalEditarDatosPersonales";
import Swal from "sweetalert2";

import HomeProfileCard from "./HomeProfileCard";
import { MainTable, SummaryCards, PodiumCarousel } from "./RankingViews";

const currentMonth = moment().get("month");
const currentYear = moment().get("year");

const pastDate = moment().subtract(1, "months");

const Home = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [openModalEditarDatosPersonales, setOpenModalEditarDatosPersonales] =
    useState(false);
  const [openModalEditarPerfil, setOpenModalEditarPerfil] =
    useState(false);
  const handleCloseModalEditarPerfil = () =>
    setOpenModalEditarPerfil(false);
  const [cierreMensualData, setCierreMensualData] = useState([]);
  const handleCloseModalEditarDatosPersonales = () =>
    setOpenModalEditarDatosPersonales(false);

  const [selectedBrokerCorreo, setSelectedBrokerCorreo] = useState(null);

  const [metricas, setMetricas] = useState({});
  const propietarios = useSelector(
    (state) => state.app.clientes && state.app.clientes.results
  );
  const [prospectos, setProspectos] = useState([]);
  const requestGetPropietarios = useSelector(
    (state) => state.app.requestGetClientes && state.app.requestGetClientes
  );
  let propiedades = useSelector(
    (state) =>
      state.app.allPropiedadesPaginadas && state.app.allPropiedadesPaginadas.results
  );
  const requestAllPropiedadesPaginadas = useSelector(
    (state) => state.app.requestAllPropiedadesPaginadas
  );
  const prospectosCA = useSelector((state) =>
    state.app.prospectosCA && state.app.prospectosCA.results
      ? state.app.prospectosCA.results
      : []
  );
  const requestGetProspectosCA = useSelector(
    (state) => state.app.requestGetProspectosCA
  );
  const prospectosVA = useSelector((state) =>
    state.app.prospectosCA && state.app.prospectosVA.results
      ? state.app.prospectosVA.results
      : []
  );
  const requestGetProspectosVA = useSelector(
    (state) => state.app.requestGetProspectosVA
  );
  const requestGetUsuario = useSelector((state) => state.app.requestGetUsuario);
  const requestStateUpdate = useSelector(
    (state) => state.app.requestUpdateUsuario
  );
  const errorMessage = useSelector((state) => state.app.errorMessage);
  const userData = useSelector((state) => state.app.usuario);
  const itemUsuario = useSelector((state) => state.app.itemUsuario);
  useEffect(() => {
    dispatch(getUsuario());
    const fetchCierres = async () => {
      try {
        const data = await dispatch(getLatestCierreMesBroker());
        if (data && Array.isArray(data)) {
          setCierreMensualData(data);
        } else if (data && data.value) {
          setCierreMensualData(data.value);
        } else if (data && data.data) {
          setCierreMensualData(data.data);
        }
      } catch (error) {
        console.error("Error fetching cierre mensual latest", error);
      }
    };
    fetchCierres();
  }, []);
  useEffect(() => {
    if (userData) {
      dispatch(
        getAllPropiedadesPaginadas(
          "",
          userData.tipoCuenta === 10 ? userData.userId : "",
          0,
          999,
          "todos",
          "createdAtDescending",
          "",
          "",
          "",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          "",
          "",
          ""
        )
      )
    };
    dispatch(getProspectos("ca", 0, 999, "", "", "", 0, 0));
    dispatch(getProspectos("va", 0, 999, "", "", "", 0, 0));
    //dispatch(getUsuario());
    dispatch(getClientesPaginados(0, 999, "true"));
  }, [userData, itemUsuario]);

  useEffect(() => {
    if (
      requestAllPropiedadesPaginadas === "LOADING" ||
      requestGetProspectosVA === "LOADING" ||
      requestGetProspectosCA === "LOADING"
    ) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [
    requestAllPropiedadesPaginadas,
    requestGetProspectosVA,
    requestGetProspectosCA,
  ]);

  useEffect(() => {
    let propiedadesCurrentMonth = [];
    let propiedadesPastMonth = [];
    let propiedadesCurrentMonthVenta = [];
    let propiedadesCurrentMonthArriendo = [];
    let propiedadesVenta = [];
    let propiedadesArriendo = [];
    let propiedadesCerradas = [];
    let comisiones = 0;
    let comunas = new Set();

    if (
      propiedades &&
      propiedades.length > 0 &&
      requestAllPropiedadesPaginadas !== "LOADING"
    ) {
      propiedades.map((p) => {
        if (!comunas.has(p.comuna)) {
          comunas.add(p.comuna);
        }

        const fechaCreacion = moment(p.createdAt.split("T")[0]);
        if (
          fechaCreacion.month() === currentMonth &&
          fechaCreacion.year() === currentYear
        ) {
          propiedadesCurrentMonth.push(p);
          if (p.planContratado !== null) {
            if (p.planContratado.esVenta) {
              propiedadesCurrentMonthVenta.push(p);
            } else {
              propiedadesCurrentMonthArriendo.push(p);
            }
          }
        }

        if (
          fechaCreacion.month() === pastDate.month() &&
          fechaCreacion.year() === pastDate.year()
        ) {
          propiedadesPastMonth.push(p);
        }

        if (p.planContratado !== null) {
          if (p.planContratado.esVenta) {
            propiedadesVenta.push(p);
          } else {
            propiedadesArriendo.push(p);
          }
        }

        const fechaTermino = moment(p.fechaTermino.split("T")[0]);
        if (
          fechaTermino &&
          fechaTermino.year() !== null &&
          fechaTermino.year() !== undefined &&
          fechaTermino.year().toString().includes("20")
        ) {
          if (
            fechaTermino.month() === currentMonth &&
            fechaTermino.year() === currentYear
          ) {
            propiedadesCerradas.push(p);
            if (p.planContratado !== null) {
              if (p.planContratado.esVenta) {
                comisiones = comisiones + p.valorCompraPropiedad * 0.5;
              } else {
                comisiones = comisiones + p.valorCompraPropiedad * 0.5;
              }
            }
          }
        }
      });
    }
    let mejoraCaptacionPropiedades =
      propiedadesCurrentMonth.length - propiedadesPastMonth.length;

    dispatch(setComunas(comunas));
    setMetricas({
      ...metricas,
      comisiones,
      propiedadesArriendo,
      propiedadesVenta,
      propiedadesCerradas,
      mejoraCaptacionPropiedades: `${mejoraCaptacionPropiedades}`,
      propiedadesCaptadasCurrentMonth: propiedadesCurrentMonth,
      propiedadesCaptadasPastMonth: propiedadesPastMonth,
      propiedadesCaptadasCurrentMonthVenta: propiedadesCurrentMonthVenta,
      propiedadesCaptadasCurrentMonthArriendo: propiedadesCurrentMonthArriendo,
    });
  }, [propiedades, requestAllPropiedadesPaginadas]);

  useEffect(() => {
    let prospectosCurrentMonth = [];
    let prospectosPastMonth = [];
    let prospectosCAcaptados = [];
    let prospectosVAcaptados = [];
    var prospectosUnion = [...new Set([...prospectosCA, ...prospectosVA])];
    setProspectos(prospectosUnion);
    if (
      prospectosUnion &&
      prospectosUnion.length > 0 &&
      requestGetProspectosCA !== "LOADING" &&
      requestGetProspectosVA !== "LOADING"
    ) {
      prospectosUnion.map((p) => {
        const fechaCreacion = moment(p.createdAt.split("T")[0]);
        if (
          fechaCreacion.month() === currentMonth &&
          fechaCreacion.year() === currentYear
        ) {
          prospectosCurrentMonth.push(p);

          if (p.tipoPropiedad !== null) {
            prospectosVAcaptados.push(p);
          } else {
            prospectosCAcaptados.push(p);
          }
        }

        if (
          fechaCreacion.month() === pastDate.month() &&
          fechaCreacion.year() === pastDate.year()
        ) {
          prospectosPastMonth.push(p);
        }
      });
    }
    let mejoraCaptacionProspectos =
      prospectosCurrentMonth.length - prospectosPastMonth.length;

    setMetricas({
      ...metricas,
      mejoraCaptacionProspectos: `${mejoraCaptacionProspectos}`,
      prospectosCAcaptados,
      prospectosVAcaptados,
      prospectosCaptadosCurrentMonth: prospectosCurrentMonth,
      prospectosCaptadosPastMonth: prospectosPastMonth,
    });
  }, [
    prospectosCA,
    prospectosVA,
    requestGetProspectosCA,
    requestGetProspectosVA,
  ]);

  useEffect(() => {
    let prospectosPasadosClienteCurrentMonth = [];
    let prospectosPasadosClientePastMonth = [];
    let prospectosPasadosCliente = [];

    if (
      prospectos &&
      prospectos.length > 0 &&
      propietarios &&
      propietarios.length > 0 &&
      requestGetProspectosCA !== "LOADING" &&
      requestGetProspectosVA !== "LOADING" &&
      requestGetPropietarios !== "LOADING"
    ) {
      propietarios.map((p) => {
        const fechaCreacion = moment(p.createdAt.split("T")[0]);
        if (prospectos.some((x) => x.email === p.mail)) {
          prospectosPasadosCliente.push(p);
        }
        if (
          fechaCreacion.month() === currentMonth &&
          fechaCreacion.year() === currentYear
        ) {
          if (prospectos.some((x) => x.email === p.mail)) {
            prospectosPasadosClienteCurrentMonth.push(p);
          }
        }

        if (
          fechaCreacion.month() === pastDate.month() &&
          fechaCreacion.year() === pastDate.year()
        ) {
          if (prospectos.some((x) => x.email === p.mail)) {
            prospectosPasadosClientePastMonth.push(p);
          }
        }
      });
    }
    /*
    let mejoraCaptacionProspectos = 
        prospectosCurrentMonth.length - prospectosPastMonth.length;
    */
    setMetricas({
      ...metricas,
      //mejoraCaptacionProspectos,
      prospectosPasadosCliente,
      prospectosPasadosClientePastMonth,
      prospectosPasadosClienteCurrentMonth,
    });
  }, [prospectos]);

  const { formatToThousandSeparator } = utilsFunc;

  if (requestStateUpdate === "SUCCESS") {
    Swal.fire({
      title: "Datos personales actualizados",
      text: "Se han actualizado sus datos personales exitosamente",
      icon: "success",
    }).then((result) => {
      if (result.value || result.dismiss === "backdrop") {
        handleCloseModalEditarPerfil();
        dispatch(getUsuario());
      }
    });
  }

  if (requestStateUpdate === "ERROR") {
    Swal.fire({
      title: "Error",
      text: errorMessage,
      icon: "error",
    });
  }

  return (
    <div className="contenido" style={{ minHeight: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column' }}>
      {/* <div className="header">
        <h2>Home</h2>
      </div> */}
      {isLoading && <CircularProgress />}
      {!isLoading && (
        <Box className="sobrePropiedades" sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', height: '100%', pb: 2 }}>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12}>
              <HomeProfileCard
                userData={userData}
                requestGetUsuario={requestGetUsuario}
                setOpenModalEditarPerfil={setOpenModalEditarPerfil}
              />
            </Grid>
          </Grid>

          <Box sx={{
            flexGrow: 1,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '3fr 1fr' },
            gridTemplateRows: { xs: '1fr auto', md: '1fr' },
            gap: 3,
            alignItems: 'stretch',
            minHeight: 0
          }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
              <PodiumCarousel data={cierreMensualData} />
              <MainTable
                data={cierreMensualData}
                userData={userData}
                selectedBrokerCorreo={selectedBrokerCorreo}
                setSelectedBrokerCorreo={setSelectedBrokerCorreo}
              />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: { xs: 0, md: 1 }
              }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, textTransform: 'uppercase' }}>
                  Resumen de Métricas {selectedBrokerCorreo && cierreMensualData.find(b => b.correo === selectedBrokerCorreo) ? `- ${cierreMensualData.find(b => b.correo === selectedBrokerCorreo).nombre_Broker}` : ""}
                </Typography>
                <Box sx={{ flexGrow: { xs: 0, md: 1 }, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                  <SummaryCards data={cierreMensualData} userData={userData} selectedBrokerCorreo={selectedBrokerCorreo} />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      <ModalEditarDatosPersonales
        isOpen={openModalEditarPerfil}
        values={userData}
        handleClose={handleCloseModalEditarPerfil}
      />
    </div>
  );
};

export default Home;
